import { defaultCheckoutFormStyleProps } from '../form/form-style-props';
// dependency cycle
import { useCheckoutColors } from '../providers/checkout-colors-provider';

export function useCheckoutFormFieldProps() {
  const {
    fieldFillColor,
    fieldLabelColor,
    fieldTextColor,
    fieldHintColor,
    fieldBorderColor,
    fieldActiveColor,
    fieldInsideLabelColor,
    errorColor
  } = useCheckoutColors();

  return {
    ...defaultCheckoutFormStyleProps,

    formSettings: {
      fieldColor: fieldTextColor,
      fieldActiveColor
    },

    fieldBorderColor,
    fieldFillColor,
    fieldHintColor,
    fieldInsideLabelColor,
    fieldLabelColor,
    errorColor
  };
}
